import type { MouseEvent } from 'react';
import history from '../client/service/history';
import ScrollPersistence from '../client/service/ScrollPersistence';

export const LEFT_CLICK_BUTTON = 0;
export const MIDDLE_CLICK_BUTTON = 1;
export const RIGHT_CLICK_BUTTON = 2;
export const changeAppRoute = (href: string) => history.push(href);

const openInNewTab = (href: string) => window.open(href, '_blank');
const openInExistingWindow = (href: string) => {
  ScrollPersistence.onNavigateAway();
  window.location.assign(href);
};
export const blockEvent = (event: MouseEvent) => {
  event.stopPropagation();
  event.preventDefault();
};

export type handleLinkClickType = {
  event: MouseEvent;
  href: string;
  onClick?: () => void;
  newTab?: boolean;
};

export const handleLinkClick = ({ event, href, onClick, newTab = false }: handleLinkClickType) => {
  const isLeftMouseClick = event.button === LEFT_CLICK_BUTTON;
  const isMiddleMouseClick = event.button === MIDDLE_CLICK_BUTTON;
  const defaultNotPrevented = !event.defaultPrevented;
  const notAbsoluteUrl = !/^[a-z][a-z0-9+.-]*:/.test(href);
  const hasModifiedEvent = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
  const shouldChangeAppRoute =
    notAbsoluteUrl && defaultNotPrevented && isLeftMouseClick && !hasModifiedEvent && !newTab;
  const shouldOpenInTab = hasModifiedEvent || isMiddleMouseClick || newTab;

  if (onClick) onClick();

  blockEvent(event);

  if (shouldChangeAppRoute) {
    changeAppRoute(href);
  } else if (shouldOpenInTab) {
    openInNewTab(href);
  } else if (isLeftMouseClick) {
    openInExistingWindow(href);
  }
};
